import { render } from "./ModalRecipeDetails.vue?vue&type=template&id=5faf7e69&scoped=true"
import script from "./ModalRecipeDetails.vue?vue&type=script&lang=js"
export * from "./ModalRecipeDetails.vue?vue&type=script&lang=js"

import "./ModalRecipeDetails.vue?vue&type=style&index=0&id=5faf7e69&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faf7e69"]])

export default __exports__